import { Box, Typography } from '@shared/ui';
import { LockIcon } from '@shared/ui/icons';
import { useSelector } from 'react-redux';

/**
 * Anonymous-patient placeholder shown below the Identification section
 * when the only visible row would otherwise be the Business name (DS) or
 * nothing at all (non-DS). Explains why the rest of the patient data is
 * hidden, instead of a wall of dashes.
 */
const EmptyAnonymous = () => {
  const { infoPane } = useSelector(state => state.i18n);
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        padding: '48px 24px',
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          background: 'var(--qhs-surface-hover)',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '14px',
          color: 'var(--qhs-text-3)',
        }}
      >
        <LockIcon style={{ width: 26, height: 26 }} />
      </Box>
      <Typography
        sx={{
          fontFamily: 'var(--qhs-font-head)',
          fontSize: 14,
          fontWeight: 700,
          color: 'var(--qhs-text-1)',
          mb: 0.5,
        }}
      >
        {infoPane.anonymousPatient}
      </Typography>
      <Typography
        sx={{ fontSize: 12.5, color: 'var(--qhs-text-2)', maxWidth: 280, lineHeight: 1.55 }}
      >
        {infoPane.anonymousPatientInfo}
      </Typography>
    </Box>
  );
};

export default EmptyAnonymous;
